// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import { MemberStatsBasic, MemberReasonWhy } from '@ta/social.member-common';
import { Link } from '@ta/common.routing';
import type { ViewportCategory } from '@ta/common.state';
import FollowButton from '@ta/social.follow';
import type { MemberInfo } from '@ta/social.member-types';
import { sendSearchRecordRequest, type SearchRecordData } from '@ta/search.tracking';
import trackEventAjax from '@ta/common.tracking';
import type { Profile } from '../types';

import styles from './ProfileCardNarrow.less';

import IdentitySection from './IdentitySection';

const preventClickPropagation = e => {
  e.stopPropagation();
  e.preventDefault();
};

type Props = {|
  profile: Profile,
  linkNewTabDT?: boolean,
  fullHeight?: boolean,
  trackType?: 'search' | null,
  trackPayload?: SearchRecordData,
  memberInfo?: MemberInfo,
|};

type InternalProps = {|
  ...Props,
  device: ViewportCategory, // Internal prop. Read from redux
|};

const FollowButtonWrapper = ({ profile, trackType, trackPayload }) => {
  switch (trackType) {
    case 'search': {
      return (
        <div onClick={(event: SyntheticEvent<*>) => preventClickPropagation(event)}>
          <FollowButton
            profile={profile}
            displayType="button+icon"
            size="small"
            onToggleFollow={interactionType => {
              const action = interactionType === 'FOLLOW' ? 'follow_click' : 'unfollow_click';
              trackEventAjax({
                module: 'Search_Results',
                action,
                context: `user_id=${profile.userId}`,
              });
              if (trackPayload) {
                const followButtonTrackingData = Object.assign({}, trackPayload, {
                  eventType:
                    interactionType === 'UNFOLLOW'
                      ? 'user_profile_unfollow'
                      : 'user_profile_follow',
                });
                sendSearchRecordRequest(followButtonTrackingData);
              }
            }}
          />
        </div>
      );
    }
    default:
      // disable tracking by default
      return (
        <FollowButton
          profile={profile}
          displayType="button+icon"
          size="small"
          preventClickPropagation
        />
      );
  }
};

const ProfileCardNarrow = (props: InternalProps) => (
  <Link
    href={props.profile?.route?.url}
    target={props.linkNewTabDT && props.device !== 'MOBILE' ? '_blank' : '_self'}
    className={props.fullHeight ? styles.flex_columns : ''}
  >
    <div className={`${styles.profile_wrap} ${props.fullHeight ? styles.full_height : ''}`}>
      <IdentitySection profile={props.profile} memberInfo={props.memberInfo} />
      <div className={styles.profile_stats_block}>
        <MemberStatsBasic profile={props.profile} />
      </div>
      {props.memberInfo && props.memberInfo.infoWithMember && (
        <MemberReasonWhy
          type={props.memberInfo.suggestedFolloweeType}
          reason={props.memberInfo.infoWithMember.reason}
          className={styles.reason_why}
          singleLine
        />
      )}
      <div className={styles.profile_follow_block}>
        {!props.profile.isMe && (
          <FollowButtonWrapper
            profile={props.profile}
            trackType={props.trackType}
            trackPayload={props.trackPayload}
          />
        )}
      </div>
    </div>
  </Link>
);

ProfileCardNarrow.defaultProps = {
  fullHeight: false,
  linkNewTabDT: false,
  // $FlowFixMe92
  trackType: '',
  trackPayload: {},
  memberInfo: undefined,
};

// $FlowFixMe92
export default connect(redux => ({
  device: redux.meta.device.viewportCategory,
}))(ProfileCardNarrow);
